import { Bell, Menu, Heart } from 'lucide-react';
import { NavLink, Link } from 'react-router-dom';
import { useNotifications } from '@context/NotificationContext';
import Logo from '@components/ui/Logo';

const ProfilePageHeader = ({ onOpenSettings, showSettings = true }) => {
  const { unreadCount } = useNotifications();

  return (
    <header className="sticky top-0 z-40 border-b border-surface-100/80 bg-white/90 backdrop-blur-xl dark:border-white/[0.06] dark:bg-[#070B16]/90">
      <div className="mx-auto flex h-14 max-w-3xl items-center justify-between px-4 sm:px-6">
        <Logo size="sm" to="/feed" />
        <div className="flex items-center gap-1.5">
          <NavLink
            to="/wishlist"
            className={({ isActive }) =>
              `flex h-10 w-10 items-center justify-center rounded-xl transition ${
                isActive
                  ? 'bg-brand-500/15 text-brand-600 ring-1 ring-brand-500/25 dark:bg-brand-500/20 dark:text-brand-400'
                  : 'bg-surface-100 text-surface-500 hover:bg-surface-200 hover:text-surface-700 dark:bg-surface-800 dark:text-surface-400 dark:hover:bg-surface-700 dark:hover:text-white'
              }`
            }
            aria-label="Wishlist"
          >
            {({ isActive }) => (
              <Heart size={18} strokeWidth={isActive ? 2.4 : 1.8} />
            )}
          </NavLink>
          <Link
            to="/messages"
            className="relative flex h-10 w-10 items-center justify-center rounded-xl bg-surface-100 text-surface-500 transition hover:bg-surface-200 hover:text-surface-700 dark:bg-surface-800 dark:text-surface-400 dark:hover:bg-surface-700 dark:hover:text-white"
            aria-label="Notifications"
          >
            <Bell size={18} strokeWidth={1.8} />
            {unreadCount > 0 && (
              <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-brand-500 ring-2 ring-white dark:ring-[#070B16]" />
            )}
          </Link>
          {showSettings && (
            <button
              type="button"
              onClick={onOpenSettings}
              className="flex h-10 w-10 items-center justify-center rounded-xl bg-surface-100 text-surface-500 transition hover:bg-surface-200 hover:text-surface-700 dark:bg-surface-800 dark:text-surface-400 dark:hover:bg-surface-700 dark:hover:text-white"
              aria-label="Open settings"
            >
              <Menu size={20} strokeWidth={1.8} />
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default ProfilePageHeader;
